import { useSelector, useDispatch } from 'react-redux';

// Types
import { OnboardingState } from 'Dashboard/components/Onboarding/OnboardingWizard/types';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

// Actions
import {
  advanceOnboardingStateAction,
  backOnboardingStateAction,
  updateOnboardingStateFlowTypeAction,
  submitThirdPartyBrowserEmailAction,
  updateOnboardingState,
} from 'Shared/actions/onboardingState';

export const useOnboardingState = () => {
  const dispatch = useDispatch();

  const [isAdvancingForward, toggleIsAdvancingForward] = useToggle(false);
  const [isAdvancingBack, toggleIsAdvancingBack] = useToggle(false);
  const [isUpdating, toggleIsUpdating] = useToggle(false);

  const onboardingState: OnboardingState = useSelector(state => state.onboardingState);
  const flowType = onboardingState.flowType;
  const step = onboardingState.step;
  const profile = onboardingState.profile;
  const cannotSignIntoGoogle = onboardingState.cannotSignIntoGoogle;
  const forceToDesktop = onboardingState.forceToDesktop;
  const userCreatedInMiddle = onboardingState.userCreatedInMiddle;

  const handleSubmitThirdPartyBrowserEmail = ({ email }: { email: string }) => {
    return submitThirdPartyBrowserEmailAction({ email });
  };

  const handleUpdateOnboardingStateFlowType = ({ flowType }: { flowType: string }) => {
    toggleIsUpdating();
    dispatch(updateOnboardingStateFlowTypeAction({ flowType })).then(() => {
      toggleIsUpdating();
    });
  };

  const handleUpdateOnboardingState = ({ onboardingState }) => {
    dispatch(updateOnboardingState({ onboardingState }));
  };

  const handleAdvanceOnboardingState = ({
    onboardingState,
    didSkip,
  }: Partial<{ onboardingState?: any; didSkip?: boolean }> = {}) => {
    // const handleAdvanceOnboardingState = (data: Partial<{ data?: any }> = {}) => {
    toggleIsAdvancingForward();
    dispatch(advanceOnboardingStateAction({ onboardingState, didSkip })).then(() => {
      toggleIsAdvancingForward();
    });
  };

  const handleAdvanceBackOnboardingState = () => {
    toggleIsAdvancingBack();
    dispatch(backOnboardingStateAction()).then(() => {
      toggleIsAdvancingBack();
    });
  };

  const currentUserAgentIsInAppBrowser = !!['Instagram', 'FBAV', 'FBAN'].find(substring =>
    navigator.userAgent.toLowerCase().includes(substring.toLowerCase())
  );

  const showInAppBrowserScreen = currentUserAgentIsInAppBrowser && onboardingState.showInAppBrowserScreen;

  return {
    onboardingState,
    flowType,
    profile,
    forceToDesktop,
    cannotSignIntoGoogle,
    step,
    isAdvancingForward,
    isAdvancingBack,
    isUpdating,
    handleAdvanceOnboardingState,
    handleAdvanceBackOnboardingState,
    handleUpdateOnboardingStateFlowType,
    handleSubmitThirdPartyBrowserEmail,
    handleUpdateOnboardingState,
    showInAppBrowserScreen,
    userCreatedInMiddle,
  };
};
